import type { FormatterType } from "@ext/markdown/core/edit/logic/Formatter/Formatters/typeFormats/getFormatterType";
import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";

export const questionAnswerFormatter =
	(formatter: FormatterType): NodeSerializerSpec =>
	async (state, node) => {
		const attrs: Record<string, unknown> = {
			answerId: node.attrs.answerId,
		};

		if (node.attrs.correct) attrs.correct = "true";

		await state.wrapContainer(
			formatter.openTag("questionAnswer", attrs),
			formatter.closeTag("questionAnswer"),
			node,
			async () => await state.renderContent(node),
			formatter.indentsContainers,
		);
	};
